/** 页面信息 */
export const route = {
  path: '/',
  name: 'login',
  meta: { title: 'login',hideInMenu: true },
  component: () => import('./index')
}

export default route
  